<template>
  <div id="widget-breadcrumb">
    <h1 class="clearfix">
      <div class="panel-menu-title">
        <template v-if="currCodapp == ''">
          {{ nameModule }}
          <small>{{ descModule }}</small>
        </template>
        <template v-else>
          <i class="fa" :class="fontIcon['request']"></i>
          {{ descCodapp }}
        </template>
        <template v-if="currCodapp != ''">
          <div class="pull-right codapp">
            <router-link :to="{ name: currCodapp }" class="color-skin">
              <i class="fa fa-circle"></i> 
              {{ codapp }}
            </router-link>
          </div>
        </template>
      </div>
    </h1>
    <div class="clearfix"></div>
    <ol class="breadcrumb">
      <li><router-link :to="{ name: 'home' }">Home</router-link></li>
      <template v-if="currCodapp != ''">
        <li>
          <!-- <router-link :to="{ name: currModule }"> -->
            {{ nameModule }}
          <!-- </router-link> -->
        </li>
        <li class="active">
          {{ descCodapp }}
        </li>
      </template>
      <template v-else>
        <li class="active">
          {{ nameModule }}
        </li>
      </template>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'widget-breadcrumb',
  props: [ 'fontIcon', 'currModule', 'currCodapp', 'nameModule', 'descCodapp', 'codapp', 'descModule' ]
}
</script>


// WEBPACK FOOTER //
// WidgetBreadcrumb.vue?263a8153